<h2 mat-dialog-title>
  <mat-icon class="dlg-title-icon">merge_type</mat-icon>
  {{strings['join_projects']}}
</h2>

<mat-dialog-content>
  <div class="flex-col gap-16">

    <p style="color:var(--text-secondary);font-size:var(--text-sm)">{{strings['rename_project_msg']}}</p>

    <mm-field [label]="strings['project_title']">
      <input mmInput maxlength="50" [placeholder]="strings['rename_project_placeholder']"
        [(ngModel)]="newProjectName">
    </mm-field>
    @if (!hasName()) {
      <span class="mmf-error-msg">{{strings['project_name_required']}}</span>
    }

    <div class="flex-col gap-6">
      <span class="dlg-label"><mat-icon>folder_copy</mat-icon>
        {{strings['joint_project_sum']}} ({{projects.length}})
      </span>
      <div class="dlg-list">
        @for (project of projects; track project) {
          <div class="dlg-list-item">
            <mat-icon>map</mat-icon>
            <span class="dlg-list-item__name">{{project.name}}</span>
            <div class="dlg-list-item__meta">
              <mat-icon svgIcon="mmo-polygon" [attr.aria-label]="strings['polygons']"></mat-icon>
              {{project.total_polygons}}
              <mat-icon svgIcon="mmo-spots" [attr.aria-label]="strings['spots']" style="margin-left:4px"></mat-icon>
              {{project.total_spots}}
            </div>
          </div>
        }
      </div>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="cancel()">{{strings['cancel']}}</button>
  <button mat-flat-button color="primary" [disabled]="!hasName()" (click)="save()">
    <mat-icon>merge_type</mat-icon>{{strings['create']}}
  </button>
</mat-dialog-actions>
